import { render, staticRenderFns } from "./collective-purchasing-detail.html?vue&type=template&id=12192d96&scoped=true&external"
import script from "./collective-purchasing-detail.js?vue&type=script&lang=js&external"
export * from "./collective-purchasing-detail.js?vue&type=script&lang=js&external"
import style0 from "./collective-purchasing-detail.scss?vue&type=style&index=0&id=12192d96&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12192d96",
  null
  
)

export default component.exports